import { render, staticRenderFns } from "./TitleDescriptionInfo.vue?vue&type=template&id=9fce0dc0&scoped=true"
import script from "./TitleDescriptionInfo.vue?vue&type=script&lang=js"
export * from "./TitleDescriptionInfo.vue?vue&type=script&lang=js"
import style0 from "./TitleDescriptionInfo.vue?vue&type=style&index=0&id=9fce0dc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fce0dc0",
  null
  
)

export default component.exports